<template>
    <div style="display: inline-flex">
        <el-select v-model="platform" style="width: 100px" @change="init" filterable :disabled="loading">
          <el-option v-for="c in ['android', 'ios']" :value="c" :label="c"/>
        </el-select>
        <date-range-picker v-model="form" :disabled="loading" start-placeholder="上线开始时间"
                           end-placeholder="上线结束时间" @change="init"></date-range-picker>
        <el-select v-model="form.country" style="width: 200px" @change="init" filterable
                   :disabled="loading" placeholder="全部国家" clearable>
            <el-option v-for="c in $root.country_list" :key="c.code" :value="c.code"
                       :label="c.en_name + ' (' + c.code + ')'">
                {{ c.en_name + ' (' + c.code + ')' }}
            </el-option>
        </el-select>
        <el-select :disabled="loading" v-model="form.video" clearable style="width: 100px" placeholder="激励视频">
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
        <el-select style="width: 200px" placeholder="模块" filterable v-model="form.module"
                 :disabled="loading" clearable>
          <el-option v-for="(v, k) in $root.image_module_enum" :label="v" :value="parseInt(k)"></el-option>
        </el-select>
        <el-select style="width: 200px" placeholder="分类" filterable v-model="form.category_key"
                   :disabled="loading" clearable>
            <el-option v-for="c in category_list" :value="c.key" :label="c.i18n_name.ZH_HANS"></el-option>
        </el-select>
         <el-select style="width: 200px" placeholder="来源" filterable v-model="form.source"
                   :disabled="loading" clearable>
            <el-option v-for="item in $root.sourceList" :key="item.value" :value="item.value" :label="item.label"></el-option>
        </el-select>
        <el-input style="width: 200px" placeholder="ID" v-model="form.id"
                  :disabled="loading"></el-input>
    </div>
    <downloadable-table title="素材评分" :data="dataPage" v-loading="loading" style="margin-top: 10px"
                        :summaryMethod="summaryMethod" show-summary @sort-change="sortChange" :complete="dataFilter">
        <el-table-column label="ID" width="150" prop="image_id"></el-table-column>
        <el-table-column label="预览图" width="120">
            <template #default="scope">
                <el-image style="width: 100px" lazy
                          :src="`${$root.cdn_url}/${scope.row.thumbnail}`"></el-image>
            </template>
        </el-table-column>
        <el-table-column label="分类" width="80" prop="category" sortable>
            <template #default="scope">
                <template v-for="c in scope.row.categories">
                    <template v-for="cate in category_list">
                        <el-tag v-if="c === cate.key">{{ cate.i18n_name.ZH_HANS }}</el-tag>
                    </template>
                </template>
            </template>
        </el-table-column>
          <el-table-column label="来源" prop="source" width="80">
            <template #default="scope">
                {{ scope.row.source }}
            </template>
        </el-table-column>
        <el-table-column label="模块" width="100" prop="module"></el-table-column>
        <!-- <el-table-column label="平台" width="100" prop="platform"></el-table-column> -->
        <el-table-column label="激励" width="80" prop="level">
            <template #default="scope">
                {{ scope.row.video ? '是' : '否' }}
            </template>
        </el-table-column>
        <el-table-column label="动图" width="80">
          <template #default="scope">
            {{ scope.row.animation ? '是' : '' }}
          </template>
        </el-table-column>
        <el-table-column label="上线时间" width="140" prop="create_date" sortable></el-table-column>
        <el-table-column label="3日价值">
          <el-table-column label="展示" prop="impression_3" width="100" sortable></el-table-column>
          <el-table-column label="展示(u)" prop="impression_u_3" width="100" sortable></el-table-column>
          <el-table-column label="进入数" prop="enter_3" width="100" sortable></el-table-column>
          <el-table-column label="进入数(u)" prop="enter_u_3" width="100" sortable></el-table-column>
          <el-table-column label="进入率" prop="enter_rate_3" width="100" sortable>
            <template #default="scope">
              {{ scope.row.enter_rate_3 }}%
            </template>
          </el-table-column>
          <el-table-column label="进入率(u)" prop="enter_rate_u_3" width="100" sortable>
            <template #default="scope">
              {{ scope.row.enter_rate_u_3 }}%
            </template>
          </el-table-column>
          <el-table-column label="完成率" prop="finish_rate_3" width="100" sortable>
            <template #default="scope">
              {{ scope.row.finish_rate_3 }}%
            </template>
          </el-table-column>
          <el-table-column label="完成率(u)" prop="finish_rate_u_3" width="100" sortable>
            <template #default="scope">
              {{ scope.row.finish_rate_u_3 }}%
            </template>
          </el-table-column>
          <el-table-column label="分享率" prop="share_rate_3" width="100" sortable>
            <template #default="scope">
              {{ scope.row.share_rate_3 }}%
            </template>
          </el-table-column>
          <el-table-column label="分享率(u)" prop="share_rate_u_3" width="100" sortable>
            <template #default="scope">
              {{ scope.row.share_rate_u_3 }}%
            </template>
          </el-table-column>
        </el-table-column>
    </downloadable-table>
    <div style="margin-top: 20px;text-align: center">
        <el-pagination v-model:current-page="page" :page-size="size" layout="prev, pager, next"
                       :total="dataFilter.length"></el-pagination>
    </div>
</template>

<script>
import axios from "ts-axios-new";
import DateRangePicker from "../base/DateRangePicker";
import DownloadableTable from "../base/DownloadableTable";
import {getProduct} from "../libs/app";

export default {
    name: "Score",
    components: {DownloadableTable, DateRangePicker},
    data() {
        return {
            loading: false, category_list: [], data: [], page: 1, size: 20, platform: 'ios',
            form: {
                start: null,
                end: null,
                country: null,
                source: null,
                category_key: null,
                enter: 1,
                finish: 2,
                download: 4,
                share: 5,
                id: null,
                video: null,
                module: null,
            }
        }
    },
    methods: {
      getProduct,
        init() {
            this.loading = true;
            axios.all([
                axios.get(`/cms/v1/score`, {
                    params: {
                        country: this.form.country,
                        start: this.form.start,
                        end: this.form.end,
                        platform: this.platform,
                    }
                }).then(res => {
                    this.data = res.data.data.metricList;
                }),
            ]).then(_ => {
                this.data.forEach(d => {
                    d.enter_rate_3 = d.impression_3 ? parseInt(d.enter_3 / d.impression_3 * 10000) / 100.0 : null;
                    d.finish_rate_3 = parseInt(d.finish_3 / d.enter_3 * 10000) / 100.0 || 0;
                    d.download_rate_3 = parseInt(d.download_3 / d.finish_3 * 10000) / 100.0 || 0;
                    d.share_rate_3 = parseInt(d.share_3 / d.finish_3 * 10000) / 100.0 || 0;
                    d.enter_rate_7 = d.impression_7 ? parseInt(d.enter_7 / d.impression_7 * 10000) / 100.0 : null;
                    d.finish_rate_7 = parseInt(d.finish_7 / d.enter_7 * 100) / 100.0 || 0;
                    d.share_rate_7 = parseInt(d.share_7 / d.finish_7 * 10000) / 100.0 || 0;
                    d.enter_rate_u_3 = d.impression_u_3 ? parseInt(d.enter_u_3 / d.impression_u_3 * 10000) / 100.0 : null;
                    d.finish_rate_u_3 = parseInt(d.finish_u_3 / d.enter_u_3 * 10000) / 100.0 || 0;
                    d.share_rate_u_3 = parseInt(d.share_u_3 / d.finish_u_3 * 10000) / 100.0 || 0;
                });
                // this.sortChange({});
                this.loading = false;
            })
        },
        resort() {
            this.data.forEach(d => {
                d.score = this.form.enter * d.enter_7 + this.form.finish * d.finish_7 / d.enter_7 + this.form.download * d.download_7 / d.finish_7 + this.form.share * d.share_7 / d.finish_7;
            });
            this.data.sort(function (a, b) {
                return b.score - a.score;
            })
        },
        sortChange({column, prop, order}) {
            if (prop) {
                this.data.sort(function (a, b) {
                    return order === 'descending' ? (b[prop] < a[prop] ? -1 : 1) : (a[prop] < b[prop] ? -1 : 1);
                })
            } else {
                this.data.sort(function (a, b) {
                    return b.enter_rate_3 - a.enter_rate_3;
                })
            }
        },
        summaryMethod({columns, data}) {
          const summary = [];
          let enter = 0, impression = 0, finish = 0, share = 0, hint = 0, duration = 0, t = 0, exit = 0;
          this.dataFilter.forEach(d => {
            enter += d.enter_3;
            impression += d.impression_3;
            finish += d.finish_3;
            share += d.share_3;
            // hint += d.hint_3;
            // duration += d.duration_3;
            // exit += d.exit_3;
            t += 1;
          });
          columns.forEach((c, i) => {
            if (c.property === 'enter_3') {
              summary[i] = Math.round(enter / t);
            } else if (c.property === 'impression_3') {
              summary[i] = Math.round(impression / t);
            } else if (c.property === 'enter_rate_3') {
              summary[i] = parseInt(enter / impression * 10000) / 100 + '%';
            } else if (c.property === 'finish_rate_3') {
              summary[i] = parseInt(finish / enter * 10000) / 100 + '%';
            } else if (c.property === 'share_rate_3') {
              summary[i] = parseInt(share / finish * 10000) / 100 + '%';
            }
            // } else if (c.property === 'hint_3') {
            //   summary[i] = (hint / enter).toFixed(2);
            // } else if (c.property === 'duration_3') {
            //   summary[i] = (duration / enter).toFixed(2) + '秒';
            // } else if (c.property === 'duration_3_new') {
            //   if (exit) {
            //     summary[i] = (duration / exit).toFixed(2) + '秒';
            //   }
            // }
          });
          return summary;
        },
    },
    mounted() {
        this.loading = true;
        axios.get('/cms/v1/category').then(res => {
            this.category_list = res.data.data.categoryList;
            this.init();
        })
    },
    computed: {
        dataFilter() {
            return this.data.filter(d => {
                let valid = d.impression_3 > 0;
                valid &= !this.form.id || d.image_id.includes(this.form.id);
                valid &= !this.form.category_key || d.categories && d.categories.includes(this.form.category_key);
                valid &= !this.form.module || d.module === this.form.module;
                valid &= !this.form.source || d.source === this.form.source;
                valid &= this.form.video == null || (this.form.video && d.cost && d.cost > 0) || (!this.form.video && !d.cost)
                return valid;
            })
        },
        dataPage() {
            return this.dataFilter.slice((this.page - 1) * this.size, this.page * this.size)
        }
    }
}
</script>

<style scoped>

</style>